import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=dc4c1958&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&lang=js&"
export * from "./ExportButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=dc4c1958&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4c1958",
  null
  
)

export default component.exports